import { Alert, AlertTitle, Container, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Radio, RadioGroup, Switch, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import AutocompleteAddress from "../../../components/AutocompleteAddress";
import TextInput from "../../../components/forms/TextInput";
import { AD_TYPE } from "../../../constants/articles";
import { toNumber } from "../../../services/helper";
import { useGetSettings, useGetVendors } from "../../../services/ContentManager";
import ResponsiveCircularLoading from "../../../components/ResponsiveCircularLoading";

export function ArticleAdvertisement({ data, setData, errors, uid }) {
    const { t } = useTranslation();
    const { settings, status: settingsStatus } = useGetSettings();
    const { vendors: vendor, status: vendorStatus } = useGetVendors(uid);
    const visualizationCost = settings?.find(s => s.name === 'advertisement_visualization_cost')?.value || 0;
    const visualizationWarningThreshold = settings?.find(s => s.name === 'advertisement_warning_threshold')?.value || 0;

    return (
        <Grid container rowGap={2} >
            {(vendorStatus === 'loading' || settingsStatus === 'loading') ?
                <ResponsiveCircularLoading />
                :
                <>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Typography variant={'h6'} fontWeight={'bold'}>
                            {t('adTitle')}
                        </Typography>
                        <Typography>
                            {t('adDescription')} {t('adCost', { count: parseFloat(visualizationCost) })}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Container maxWidth={"md"}>
                            <Box sx={{
                                '& .MuiFormControlLabel-root': {
                                    justifyContent: 'center'
                                }
                            }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Switch checked={data.isAdvertisementActive}
                                            onChange={(e) => setData({
                                                ...data,
                                                isAdvertisementActive: e.target.checked
                                            })} />} label={t('startAd')} />
                                </FormGroup>
                            </Box>

                            <FormControl sx={{ ml: '5em' }} disabled={!data.isAdvertisementActive}>
                                <FormLabel
                                    id="demo-radio-buttons-group-label">{t('adRange')}</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    name="radio-buttons-group"
                                    value={data.advertisementType}
                                    onChange={(e) => setData({
                                        ...data,
                                        advertisementType: toNumber(e.target.value),
                                    })}
                                >
                                    <FormControlLabel value={AD_TYPE.distance} control={<Radio />}
                                        label={t('adDistance')} />
                                    <Box sx={{ p: 1 }}>
                                        <TextInput
                                            color={'primary'}
                                            type={'number'}
                                            min={0}
                                            onTextChange={(value) => setData({
                                                ...data,
                                                advertisementValueDistance: value
                                            })}
                                            disabled={!data.isAdvertisementActive ? true : toNumber(data.advertisementType) !== AD_TYPE.distance}
                                            value={data.advertisementValueDistance}
                                            error={errors.distance}
                                            startAdornment={'km'}
                                        />
                                    </Box>

                                    <FormControlLabel value={AD_TYPE.country} control={<Radio />}
                                        label={t('adCountry')} />
                                    <Box sx={{ p: 1 }}>
                                        <AutocompleteAddress
                                            label={t('country')}
                                            value={data.advertisementValueCountry || ''}
                                            onAddressInputChange={() => {
                                            }}
                                            onAddressSelect={(value) => setData({
                                                ...data,
                                                advertisementValueCountry: value
                                            })}
                                            types={["country"]}
                                            disabled={!data.isAdvertisementActive ? true : toNumber(data.advertisementType) !== AD_TYPE.country}
                                            error={errors.country}
                                        />

                                    </Box>

                                    <FormControlLabel value={AD_TYPE.allUsers} control={<Radio />}
                                        label={t('adAllUsers')} />
                                </RadioGroup>
                            </FormControl>
                        </Container>
                    </Grid>
                    {
                        vendor.points <= visualizationWarningThreshold &&
                        <>
                            <Grid item xs={12} sx={{ marginBottom: "0.3rem", p: 2 }}>
                                <Container maxWidth={'md'}>
                                    <Alert severity="warning">
                                        <AlertTitle sx={{
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase'
                                        }}>{t('warning')}</AlertTitle>
                                        {t('advertisementWarning')}
                                    </Alert>
                                </Container>
                            </Grid>
                        </>
                    }
                </>
            }
        </Grid>
    );
}